import cookie from '@motionelements/core/src/store/modules/cookie.js';

export default {
  namespaced: true,
  state: () => cookie.state,
  getters: cookie.getters,
  actions: cookie.actions,
  mutations: cookie.mutations,
};
